import cn from 'classnames';
import gtag from '../analytics/gtag';
import type { UserData } from '../api/product';
import { getProductInWishlists } from '../api/wishlist';
import AsyncButton from '../generic/forms/AsyncButton';
import Icon from '../generic/Icon';
import { ProductListModal } from '../generic/Modals';
import useUser from '../login/userContext';
import type { ProductCardDetails } from '../product/ProductCard';
import * as style from './ProductListTool.module.css';

interface Props {
    product: ProductCardDetails;
    inList: boolean | undefined;
    onUserDataChange(userData: UserData): void;
}

export default function ProductListTool({ product, inList = false, onUserDataChange }: Props) {
    const { showLoginModal } = useUser();

    const openModal = async () => {
        if (showLoginModal()) return;
        const { lists, favourite, sorts } = await getProductInWishlists(product.code);
        ProductListModal.upsert({
            lists,
            favourite,
            sorts,
            onUserDataChange,
            product,
        });
        gtag('event', 'modal_view', {
            modal_name: 'ProductListTool',
            item_id: product.code,
        });
    };

    return (
        <AsyncButton className="btn-icon" onClick={openModal} title="Min liste" aria-label="Min liste">
            <Icon className={cn(style.iconReview, { [style.iconReviewList]: inList })} />
        </AsyncButton>
    );
}
